<template>
  <div class="flex justify-between items-center py-5 mr-3">
    <input
      v-if="position === 'header'"
      class="menu-btn hidden"
      type="checkbox"
      id="menu-btn"
    />
    <label
      v-if="position === 'header'"
      class="menu-icon header-text-color block cursor-pointer md:hidden relative select-none"
      for="menu-btn"
    >
      <i class="fas fa-bars text-3xl"></i>
      <i class="fas fa-times text-3xl"></i>
    </label>
    <div
    
      class="flex flex-1 flex-wrap justify-end items-center pl-3 text-base text-white capitalize menu header-bg-color header-text-color"
    >
      <div
        class="px-3 header-text-color"
        :class="[!isPreview ? 'pointer-events-none' : 'cursor-pointer']"
        v-for="(menu, index) in activeMenus"
        :key="index"
      >
        <a
          @click="
            isPreview
              ? menu.page_type == 2 && menu.external_link
                ? sendToExternalUrl(menu.external_link, menu.open_new_tab)
                : sendToPath({
                    name: menu.is_default ? 'home' : 'page',
                    params: menu.is_default ? {} : { slug: menu.slug },
                  })
              : () => {}
          "
          >{{ menu.name }}</a
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MenuItems',
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      default: () => {
        return 'header';
      },
    },
    activeMenus: {
      type: Array,
      default: () => {
        return [];
      },
    },
    sendToPath: {
      type: Function,
      default: () => {},
    },
    sendToExternalUrl: {
      type: Function,
      default: (url, newTab) => {
        window.open(url, newTab ? '_blank' : '_self');
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.header-bg-color {
  background-color: var(--template-header-bg-color);
}
.header-text-color {
  color: var(--template-header-text-color);
}
</style>
